/**
 * Pure helpers for approval rules. Every rule is `<field> <condition> <value>`;
 * the field's `type` decides what kind of input the value needs.
 */

/** A client-side placeholder for a rule that has not been created yet. */
export const DRAFT_RULE_GUID = "__draft__";

export function createRuleDraft() {
  return {
    guid: DRAFT_RULE_GUID,
    description: "",
    field: null,
    condition: "",
    value: "",
    isNew: true,
  };
}

export function getFieldById(fieldId, fields = []) {
  if (fieldId === "" || fieldId == null) return null;
  return fields.find((field) => field.id === Number(fieldId)) ?? null;
}

/**
 * A "select" field encodes its options in the type string as
 * `select|[{"id":…,"name":…}]`.
 */
export function isSelectField(type) {
  return Boolean(type?.split("|").includes("select"));
}

export function parseSelectFieldType(type) {
  if (!type?.includes("|")) return null;
  try {
    return JSON.parse(type.split("|")[1]);
  } catch {
    return null;
  }
}

export function formatRuleCondition(conditionId, allowedConditions = []) {
  return allowedConditions.find((item) => item.id === conditionId)?.name ?? conditionId;
}

/** Dates round-trip as `YYYY-MM-DD` for the date input. */
export function toRuleDateValue(value) {
  if (!value) return "";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "" : date.toISOString().slice(0, 10);
}

export function getRuleValueForEditing(rule) {
  if (rule?.field?.type === "datetime") return toRuleDateValue(rule.value);
  return rule?.value ?? "";
}

/** Form state -> the body the create/update endpoints expect. */
export function toApprovalRulePayload({ guid, description, fieldId, condition, value }) {
  const payload = { description, fieldId: Number(fieldId), condition, value };
  return guid && guid !== DRAFT_RULE_GUID ? { ...payload, guid } : payload;
}
